module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feed pb-5"
  }, _vm._l((_vm.cards), function(card) {
    return (_vm.filter == card.category || _vm.filter == 'today') ? _c('div', [(card.visible) ? _c('dashboard-feedcard' + card.type, {
      tag: "div",
      attrs: {
        "cardInfo": card
      }
    }) : _vm._e()], 1) : _vm._e()
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-70570c32", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70570c32"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Feed.vue
// module id = 1526
// module chunks = 0